/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Addressbookapiurl3Inputs */

const en_entity_addressbookapiurl3 = /** @type {(inputs: Entity_Addressbookapiurl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address Book API URL`)
};

const de_entity_addressbookapiurl3 = /** @type {(inputs: Entity_Addressbookapiurl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adressbuch API URL`)
};

/**
* | output |
* | --- |
* | "Address Book API URL" |
*
* @param {Entity_Addressbookapiurl3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_addressbookapiurl3 = /** @type {((inputs?: Entity_Addressbookapiurl3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Addressbookapiurl3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_addressbookapiurl3(inputs)
	return de_entity_addressbookapiurl3(inputs)
});
export { entity_addressbookapiurl3 as "entity_addressBookApiUrl" }